<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="合同编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.contractFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
            <el-form-item label="产品编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.productFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
            <el-form-item label="调价时间" prop="billNo" style="width: 28%;">
              <el-date-picker
                  style="width: 100%"
                  v-model="valueTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
              />
<!--              <el-date-picker-->
<!--                  v-model="formInline.cdateStart"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
<!--              <span class="w-time-to">至</span>-->
<!--              <el-date-picker-->
<!--                  v-model="formInline.cdateEnd"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
            </el-form-item>
            <el-form-item label="供应商编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.customerFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
          </div>
<!--          <div class="h-thirdColumn w-newColumn">-->
<!--            <el-form-item label="供应商编码/名称" prop="billNo" style="width: 25%;">-->
<!--              <el-input v-model="formInline.customerFuzzyQuery" placeholder="请输入"-->
<!--                        style="width: 100%" />-->
<!--            </el-form-item>-->
<!--          </div>-->
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            max-height="450"
        >
          <el-table-column
              label="合同编号"
              prop="ccode"
              width="120"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="合同名称"
              prop="contractName"
              width="120"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商编码"
              prop="customerCode"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商名称"
              prop="customerName"
              width="200"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品编码"
              prop="productId"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品名称"
              prop="productName"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="税率"
              prop="shuilv"
              width="60"
              show-overflow-tooltip>
            <template slot-scope="scope">
              <dictname category="cgshuilv"  :v="scope.row.shuilv"/>
            </template>
          </el-table-column>
          <el-table-column
              label="原价格"
              prop="oldUnitPrice"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ cleanNumber(scope.row.oldUnitPrice).toString() }}
            </template>
          </el-table-column>
          <el-table-column
              label="调整后价格"
              prop="unitPrice"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ cleanNumber(scope.row.unitPrice).toString() }}
            </template>
          </el-table-column>
          <el-table-column
              label="价差"
              prop="priceSpread"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ calculatePriceDiff(scope.row.unitPrice, scope.row.oldUnitPrice) }}
            </template>
          </el-table-column>
          <el-table-column
              label="调价人"
              prop="cuname"
              width="70"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="调价时间"
              prop="cdate"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
                  label="状态"
                  prop="status"
                  width="140"
                  show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">审批通过</span>
              <span v-if="scope.row.status==2">审批中</span>
              <span v-if="scope.row.status==3">审批驳回</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="备注"
                  prop="bz"
                  width="140"
                  show-overflow-tooltip>
          </el-table-column>
          <el-table-column
                  fixed="right"
                  label="操作"
                  width="150" >
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button
                        v-if="'3' == scope.row.status || scope.row.status == '' || scope.row.status == null"
                        type="text"
                        size="small"
                        @click="beian(scope.row)"
                        class="h-tableLink h-btn">
                  备案
                </el-button>
                <el-button
                        @click="lookFile(scope.row)"
                        v-if="null != scope.row.instid && '' != scope.row.instid"
                        type="text"
                        size="small"
                        class="h-tableLink h-btn">
                  查看附件
                </el-button>
                <el-button
                        v-if="null != scope.row.instid && '' != scope.row.instid"
                        type="text"
                        size="small"
                        class="h-tableLink h-btn"
                        @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
<!--        <div class="h-tableBL">-->
<!--          <el-button type="primary" @click="exportExcel">批量导出</el-button>-->
<!--        </div>-->
        <div class="h-pagination2">
          <pagination :page="formInline" @query="query"/>
        </div>
      </div>

      <el-dialog :close-on-click-modal="false" class="h-dialog2" :visible.sync="beianflag">
        <!-- dialogImg -->
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>备案</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
          <el-form :model="f"  class="demo-form-inline h-formBorder">
            <el-form-item label="备注" class="h-elformWrap-2" style="margin-left:0.5rem;width: 80%">
              <el-input v-model="f.bz" type="textarea" auto-complete="off"></el-input>
            </el-form-item>
            <br>
            <el-form-item label="备案记录" class="h-elformWrap-2" style="margin-left:0.5rem;" :rules="[
                  { required: true, message: '请上传撤单申请书', trigger: 'change'},
                ]">

              <brupload
                      :refid="refid"
                      reftype="采购调价记录备案"
                      :limit="1"
                      :showtime="false"
                      uploadflag
                      delflag
              >
              </brupload>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
          <el-button class="h-btn h-bBtn" @click="fqbeian">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :close-on-click-modal="false"  class="new-dialog" :visible.sync="seebeianflag">
        <!-- dialogImg -->
        <div class="h-dialogImg">
          <h3>备案</h3>
        </div>
        <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
          <h3 style="display: inline-block;">备注:</h3>
          <h4 style="display: inline-block;margin-left: 0.1rem;">{{cgbz}}</h4>
        </div>
        <div class="h-formLine" style="padding:20px;">
          <h3 style="display: inline-block;">附件</h3>
          <brupload
                  style="margin-top: 0.1rem;"
                  :refid="refid"
                  reftype="采购调价记录备案"
                  :uploadflag="false"
                  :delflag="false"
                  :showtime="false"
                  :tpFlag = 'true'
                  />
        </div>
      </el-dialog>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>
<script>
import reduceCost from "@/api/invoice/reduceCost";
export default {
  data() {
    return {
      formInline:{
        contractFuzzyQuery: '',
        productFuzzyQuery: '',
        customerFuzzyQuery: '',
        cdateStart: '',
        cdateEnd: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      f:{
        id: '',
        bz: '',
      },
      valueTime: 0,
      beianflag:false,
      seebeianflag:false,
      showhistory:false,
      instid:null,
      refid:null,
      tableData: []
    }
  },
  methods:{
    // 清洗单个数值：统一格式为“最多2位小数，无小数显整数”
    cleanNumber(value) {
      // 步骤1：处理空值/非数值（如null/undefined/""，默认按0处理）
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      // 步骤2：转为数字类型（处理字符串格式的数值，如"10.00"→10.00）
      const num = Number(value);
      // 步骤3：确保是有效数字（避免NaN，无效数字按0处理）
      if (isNaN(num)) {
        return 0;
      }
      // 步骤4：保留2位小数→转数字（去末尾0）→返回处理后的值（数字类型）
      return Number(num.toFixed(2));
    },

    // 计算价格差值并格式化最终结果
    calculatePriceDiff(unitPrice, oldUnitPrice) {
      // 步骤1：分别清洗两个参数（确保格式统一）
      const cleanedUnitPrice = this.cleanNumber(unitPrice);
      const cleanedOldUnitPrice = this.cleanNumber(oldUnitPrice);

      // 步骤2：计算差值（处理浮点数精度问题）
      const diff = (cleanedUnitPrice * 100 - cleanedOldUnitPrice * 100) / 100;

      // 步骤3：格式化差值（最多2位小数，不补0）
      return Number(diff.toFixed(2)).toString();
    },
    changeTime(date){
      if(date){
        this.formInline.cdateStart = date[0];
        this.formInline.cdateEnd = date[1];
      }else{
        this.formInline.cdateStart = '';
        this.formInline.cdateEnd = '';
      }
    },
    handleFilter(){
      this.formInline.pageNo = 1
      this.query()
    },
    resetData(){
      this.formInline = {
        contractFuzzyQuery: '',
        productFuzzyQuery: '',
        customerFuzzyQuery: '',
        cdateStart: '',
        cdateEnd: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.valueTime = []
      this.query()
    },
    query(){
      reduceCost.selectCgShenpiPage(this.formInline).then(res => {
        this.tableData = res.records;
        this.formInline.total = res.total;
      })
    },
    beian(v){
      this.beianflag = true;
      this.f.id = v.id;
      this.refid = this.$util.getUuid();
    },
    cancel(){
      this.beianflag = false;
    },
    genzongLiuch(r) {
      console.log(r);
      this.instid = r.instid;
      this.showhistory = true;
    },
    lookFile(v){
      this.cgbz = v.bz;
      this.refid = v.refid;
      this.seebeianflag = true;
    },
    fqbeian(){
      this.$msg.confirm("确认提交？", () => {
        this.f.refid = this.refid;
        reduceCost.contractCgBeiAnShenpi(this.f).then(res => {
          if(res.f == true ){
            this.$msg.alerts("提交成功！",()=>{
              this.beianflag = false;
              this.query();
            })
          }
        })
      })
    },
    // exportExcel(){
    //
    // }
  },
  created() {
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator{
  padding: 0px 20px 0px 6px;
}
</style>
<!--弹窗样式开始-->
<style scoped>
  .commodityMaintenanceBox > .h-piece, .h-mrt30 {
    margin: 20px;
  }

  .h-formBtnOut .h-mr20 {
    margin-left: 3rem !important;
  }

  /deep/ .el-dialog__header {
    padding: 0
  }

  /deep/ .el-dialog {
    border-radius: 0.1rem;
    width: 7.89rem;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-dialog__header {
    background: #2785E7
  }

  /deep/ .el-dialog__headerbtn .el-dialog__close {
    height: 0.56rem;
    width: 0.56rem;
    line-height: 0.56rem;
    text-align: center;
    background-color: #fff;
    color: #015ba0;
    border-radius: 100%;
    font-size: 0.34rem;
  }

  .h-dialogImg {
    height: 1.62rem;
    background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
    background-size: 7.89rem;
    padding-left: 4.02rem;
  }

  .h-dialogImg h3 {
    text-align: left;
    padding: .6rem 0 0 0;
    font-size: 0.3rem;
    color: #fff;
    font-weight: normal;
    letter-spacing: 0.02rem;
  }

  .addDeliveryForm {
    padding: 0.54rem 0.28rem 0 0.25rem;
  }
  .addDeliveryForm /deep/ .el-form-item{
    width: 48%;
    float: left;
  }
  .addDeliveryForm /deep/ .el-form-item__label {
    width: 84px;
    font-size: 0.18rem;
    color: #4a4a4a;
    line-height: 0.28rem;
    vertical-align: top;
    padding-right: 5px;
    letter-spacing: 0;
    display: inline-block;
    text-align: right;
  }
  .addDeliveryForm /deep/ .el-form-item__content {
    width: 67%
  }
  .addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
    border-radius: 0;
    background: transparent;
    color: #868686;
    border: 0;
    border-bottom: 1px solid #dedede;
    height: 0.29rem;
    line-height: 0.28rem;
    padding-left: 0.15rem;
  }

</style>